import { render, staticRenderFns } from "./BasicTableComponent.vue?vue&type=template&id=a651f416&"
import script from "./BasicTableComponent.vue?vue&type=script&lang=js&"
export * from "./BasicTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./BasicTableComponent.vue?vue&type=style&index=0&id=a651f416&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports